import type { Factory } from 'walden-fast/types/mocks';
import type { User } from 'walden-fast/types/user';
import { selectRandom } from './lists';

const MOCK_USER: User = {
  id: '1',
  firstName: 'John',
  lastName: 'Doe',
  displayName: 'John Doe',
  email: 'johndoe@walden-group.com',
  preferredLanguage: 'en-US',
  availableServices: [],
  role: 'AccountAdministrator',
  client: 'Walden',
  enabledFeatures: [],
  clientCompanies: [
    { id: '1', displayName: 'XYZ' },
    { id: '2', displayName: 'DEMO' },
  ],
  account: {
    id: '1',
    displayName: 'XYZ',
    externalIdentifiers: { powerBI: { clientNameMaster: 'XYZ' } },
  },
  permissions: [],
};

export const userFactory: Factory<User> = (overrides) => ({
  ...MOCK_USER,
  id: `${Math.floor(Math.random() * 1000)}`,
  client: `Walden ${selectRandom(['BE', 'NL', 'FR'])}`,
  ...overrides,
});
